import { TextInputNumeric } from '@perpay-web/components/base/TextInputNumeric/TextInputNumeric';
import { withFormServerErrors } from '@perpay-web/components/higher-order/WithFieldServerErrors/WithFormServerErrors';

const TextInputNumericServerError = withFormServerErrors(TextInputNumeric);

export default TextInputNumericServerError;
